import React from 'react';
import LinearCarousel from '../Carousel';
import Sponsor1 from '../../assets/sponsor/genico.png'

const Sponsor = () => {
    const SponsorImages = [
        Sponsor1,
        Sponsor1,
        Sponsor1,
        Sponsor1,
        Sponsor1,
        Sponsor1,
    ];
    return (
        <div className=' p-5 sponsor my-3'>
            <h1 className='section-header mb-6'>
                Sponsors
            </h1>
            <img className=' mx-auto' src={Sponsor1} alt='sponsor'/>
            {/* <LinearCarousel images={SponsorImages} /> */}
        </div>
    );
}

export default Sponsor;
